import React from 'react';
import PageIntro from '../components/PageIntro/PageIntro';
import EditPage from '../components/FirstSection/editPostForm';

const EditBlog = ({ match }) => {
  const { postId } = match.params

  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro
        title='Edit Post'
        description='Update an existing blog article.'
      />
      <EditPage postId={postId} />
    </div>
  )
}

export default EditBlog;
